module.exports = __webpack_public_path__ + "img/icon-quality.103dd098.svg";